import { render, staticRenderFns } from "./ReceptionProducts.vue?vue&type=template&id=e6c136c2&scoped=true"
import script from "./ReceptionProducts.vue?vue&type=script&lang=js"
export * from "./ReceptionProducts.vue?vue&type=script&lang=js"
import style0 from "./ReceptionProducts.vue?vue&type=style&index=0&id=e6c136c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c136c2",
  null
  
)

export default component.exports